import { QUICK_RANGE_KEYS } from '../../utils/dateRange';

const QUICK_BUTTONS = [
  { key: QUICK_RANGE_KEYS.TODAY, label: '今日' },
  { key: QUICK_RANGE_KEYS.YESTERDAY, label: '昨日' },
  { key: QUICK_RANGE_KEYS.DAY_BEFORE, label: '前天' },
  { key: QUICK_RANGE_KEYS.THIS_WEEK, label: '本周' },
  { key: QUICK_RANGE_KEYS.LAST_WEEK, label: '上周' },
  { key: QUICK_RANGE_KEYS.THIS_MONTH, label: '本月' },
];

export default function StatFilterBar({
  startDate,
  endDate,
  activeQuick,
  loading,
  onStartChange,
  onEndChange,
  onQuickSelect,
  onSearch,
  onReset,
}) {
  return (
    <div className="stat-filter-bar">
      <div className="stat-filter-label">統計時間</div>
      <div className="stat-filter-dates">
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartChange(e.target.value)}
        />
        <span className="stat-filter-sep">→</span>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndChange(e.target.value)}
        />
      </div>
      <div className="stat-filter-quick">
        {QUICK_BUTTONS.map((btn) => (
          <button
            key={btn.key}
            type="button"
            className={`stat-quick-btn${activeQuick === btn.key ? ' active' : ''}`}
            onClick={() => onQuickSelect(btn.key)}
          >
            {btn.label}
          </button>
        ))}
      </div>
      <div className="stat-filter-actions">
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSearch}
          disabled={loading}
        >
          查詢
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onReset}
          disabled={loading}
        >
          重置
        </button>
      </div>
    </div>
  );
}
